// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"359":"2588cfeb","695":"c7f1d46d","777":"2143f7a8"}[chunkId] + ".chunk.css";
};